<template>
    <div class="page" data-page="story">
        <div class="container">

            <div v-if="story" class="pure-g">
                <div class="pure-u-1 pure-u-lg-4-5 leftArea">

                    <div class="videoArea">
                        <vue-plyr ref="plyr" :options="playerOptions">
                            <div data-plyr-provider="youtube" :data-plyr-embed-id="story.videoUrl"></div>
                        </vue-plyr>
                        
                        <!-- <div ref="plyr" id="player" class="plyr__video-embed">
                            <iframe
                                :src="`https://www.youtube.com/embed/${story.videoUrl}?origin=https://www.onemgl.com&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1&amp;hd=1`"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>
                        </div> -->
                    </div>

                    <div class="detailsArea">
                        <h3 class="title">{{ story.title }}</h3>
                        <p class="description">{{ story.desc }} <span class="date">Jan 27, 2021</span></p>
                    </div>

                    <p class="om-label">Comments</p>
                    <Comments
                        :isSmall="true"
                        :isOpen="true"
                        type="stories"
                        collectionId="stories"
                        :docId="story.id"
                        :key="story.id"
                        >
                    </Comments>
                    
                </div>
                <div class="pure-u-1 pure-u-lg-1-5 rightArea">
                    
                    <!--User Info Block-->
                    <div v-if="user" class="image top">
                        <div>
                            <div
                                class="avatar custom mb-2"
                                :style="'background-image:url('+ user.photoURL +'?width=500&height=500);'"
                            ></div>

                            <h3 class="name mb-2">{{ user.displayName }}</h3>

                            <template v-if="typeof user.location !== 'undefined'">
                                <template v-if="typeof user.location.city !== 'undefined'">
                                    <p class="location mb-2">{{ user.location.city.name }}, {{ user.location.state.name }}</p>
                                </template>
                            </template>

                            <div class="status mb-4">
                                <span v-if="user.displayName === 'Anand Davaasuren'" class="badge green">Organizer</span>
                                <span v-else-if="user.isStaff" class="badge green">{{ user.staffTitle }}</span>
                                <span v-else-if="user.isMember" class="badge yellow">Member</span>
                                <span v-else class="badge grey">User</span>
                            </div>

                            <div v-if="typeof user.instagram !== 'undefined'" class="socialIcons">
                                <a :href="`https://www.instagram.com/${user.instagram.username}/`" target="_blank" class="instagram hint hint--top" :data-hint="`@${user.instagram.username}`">
                                    <ion-icon name="logo-instagram"></ion-icon>
                                </a>
                            </div>

                            <router-link :to="`/user/${user.uid}`" class="btn secondary">Profile</router-link>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Comments from '@/components/Comments'
import moment from 'moment'

export default {
    components: {
        Comments
    },

    data(){
        return{
            story: {},
            playerOptions: {
                controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'duration',
                    'mute',
                    'volume',
                    'airplay',
                    'pip',
                    'fullscreen'
                ],
                youtube: {
                    noCookie: true
                }
            },
            user: null
        }
    },

    computed: {
        getUserData(){
            return this.$store.state.allUsers[this.story.uid]
        }  
    },

    async created(){
        let storyId = this.$route.params.id
        await this.$bind('story', this.$firebase.firestore().collection('stories').doc(storyId))

        this.user = this.getUserData

        // this.$refs.plyr.on('event', () => {
        //     console.log('Player started playing!')
        // })
    },

    filters: {
        joinedOn(value){
            return moment(value.toDate()).local().format('MMMM YYYY')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Stories/StoriesDetail.vue